<li>
  <label class="sr-only" [for]="id">{{getLabel()}}</label>
  <button
    [id]="id"
    [class]="styles"
    [ariaDisabled]="disabled"
    [ariaSelected]="isSelected"
    tabindex="-1"
    role="option"
    (click)="handleClick()"
  >
    <pax-responsive-text
      variant="sm"
      [text]="option.label ?? option.value"
      [mobileText]="option.mobileLabel ?? option.value"
    />
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      [class]="iconStyles"
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  </button>
</li>
